/* eslint-disable no-unused-vars */
import React from 'react'
import PropTypes from 'prop-types'

function Company(props) {
  return (
    <div>Company</div>
  )
}

Company.propTypes = {}

export default Company
